import * as React from 'react';
import Button from '@mui/material/Button';
import ShareIcon from '@mui/icons-material/Share'

export default function ShareMenu(props) {
    // This is a button that shares the current page on social media.
    // When not expanded, the button should say "Teilen" with the share icon.
    // When expanded, the button should display the following options:
    // - Facebook
    // - Twitter
    // - Whatsapp
    // - Mail
    // - Link kopieren

    // Everything should be implementet with MUI components. The menu should appear after clicking the button.
    // For now, only the WEB Share API is implemented. This should be replaced with the MUI menu.


    const site_to_share = props.link

    const share_site = () => {
        //if browser supports web share api, use it. Else, copy to clipboard
        if (navigator.share){
            navigator.share({ url:site_to_share }).catch(() => {/* ignore all errors, including AbortError */});
        }else{
            navigator.clipboard.writeText(site_to_share)
            alert("Link wurde in die Zwischenablage kopiert")
        }
    }

    return (
        <>

            <Button
                id="share-button"
                onClick={share_site}
            >
                <ShareIcon />
            </Button>


        </>

    )
}